// @flow
import { createAction } from "redux-act";

export const setFavourite = createAction("Set Favourite Game Selection");
export const clearFavourite = createAction("Clear Favourite Game Selection");